import { RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useUserPreference } from '@/features/user-preferences/user-preferences.hooks';
import { MyDayPanel } from '../myday/myday.panel';
import { MyWeekPanel } from './myweek.panel';
import { MyMonthPanel } from './mymonth.panel';

export const MyWorkordersPanel = (props: RoutedPanelProps) => {
  const [mode, setMode] = useUserPreference('myWorkordersView');

  if (mode === 'month') {
    return <MyMonthPanel {...props} mode={mode} onModeChange={setMode} />;
  }
  if (mode === 'week') {
    return <MyWeekPanel {...props} mode={mode} onModeChange={setMode} />;
  }
  return <MyDayPanel {...props} mode={mode} onModeChange={setMode} />;
};
